/** Where the drag ends up: too low, just right (a small gap under the roof), or touching it. */
export type DragZone = 'low' | 'right' | 'touch';

/** Below this gap (mm) the tongue touches the roof of the mouth. */
const TOUCH_MM = 1.2;
/** How far toward the /r/ shape (0 rest, 1 the shape) counts as raised enough. */
const RAISED = 0.8;

/**
 * The zone for a drag: `pose` is how far the tongue has moved from rest toward the /r/ shape, and
 * `gapMm` its narrowest gap to the roof (touching is judged by the gap, raised enough by the move,
 * since the resting tongue already lies fairly close under the soft palate).
 */
export function zoneFor(gapMm: number, pose: number): DragZone {
  if (gapMm < TOUCH_MM) return 'touch';
  return pose >= RAISED ? 'right' : 'low';
}
